class FixedIcon {
  constructor() {
    const fixedIconsWrap = document.querySelector('#fixed-icons')
    this.fixedIcons = document.querySelectorAll('[data-fixed-icon]')
    this.moreIconWrap = document.querySelector('[data-more-icon-wrap]')
    this.goBackTop = document.querySelector('[data-go-back-icon]')

    this.iconSize = fixedIconsWrap?.dataset?.iconSize
    this.threeIconSize = fixedIconsWrap?.dataset?.threeIcons

    // 所有配置的类型
    this.allTypes = fixedIconsWrap?.dataset?.allTypes?.split(',')

    // 是否配置了 拉新、红包、聊天
    this.typeArray = []
    this.fixedIcons.forEach(item => this.typeArray.push(item.dataset.type))

    if (this.iconSize > 0) {
      setTimeout(() => {
        document.getElementById('fixed-icons').style.display = 'block'
      }, 2000)

      this.init()
      this.initGoBack()
    }
    // 兼容未配置数据的场景
    else {
      // 初始化 拉新插件
      if (window.pageInfo?.settings?.open_new_customer) {
         import(/* webpackChunkName: "new-customer-pop" */ '../../plugins/new-customer-pop/index').then((module) => {
          const app = module.default;
          // 避免重复实例化
          window.customerPlugin = window.customerPlugin || new app({ initShow: true })

          console.log("jky app [new customer pop]:loaded")
          return true;
        }).catch(() => {
          console.log("jky app [new customer pop]:fail")
          return false
        })
      }
      // 初始化 红包
      if (window.pageInfo?.settings?.open_membership_packet) {
        import(/* webpackChunkName: "membership-packet" */ '../../plugins/membership-packet/index').then((module) => {
          const app = module.default;
          // 避免重复实例化
          window.redPacketPlugin = window.redPacketPlugin || new app({ initShow: true })

          console.log("jky app [membership-packet]:loaded")
          return true;
        }).catch(() => {
          console.log("jky app [membership-packet]:fail")
          return false
        })
      }
    }

    if (this.moreIconWrap) {
      this.initMoreEvent()
    }
  }
  init() {
    // 显示新的 返回顶部
    this.goBackTop.classList.remove('hidden')
    // 删除旧的 返回顶部
    const backTopDOM = document.querySelector('#back-top')
    backTopDOM?.parentElement?.removeChild(backTopDOM)


    this.fixedIcons.forEach(it => {
      // 拉新插件，实例化
      if (window.pageInfo.settings?.open_new_customer) {
        // 避免重复实例化
        import(/* webpackChunkName: "new-customer-pop" */ '../../plugins/new-customer-pop/index').then((module) => {
          const app = module.default;
          // 避免重复实例化
          window.customerPlugin = window.customerPlugin || new app({ initShow: !this.typeArray.includes('new_customer_plugin') && !this.allTypes.includes('new_customer_plugin') })

          console.log("jky app [new customer pop]:loaded")
          return true;
        }).catch(() => {
          console.log("jky app [new customer pop]:fail")
          return false
        })
      }

      // 会员红包，则实例化
      if (window.pageInfo?.settings?.open_membership_packet) {
        import(/* webpackChunkName: "membership-packet" */ '../../plugins/membership-packet/index').then((module) => {
          const app = module.default;
          // 避免重复实例化
          window.redPacketPlugin = window.redPacketPlugin || new app({ initShow: !this.typeArray.includes('red_packet') && !this.allTypes.includes('red_packet') })

          console.log("jky app [membership-packet]:loaded")
          return true;
        }).catch(() => {
          console.log("jky app [membership-packet]:fail")
          return false
        })
      }

      // 如果配置了 zendesk 客服聊天插件，则隐藏默认的
      if (
        (this.typeArray.includes('customer_service') || this.allTypes.includes('customer_service'))
        && window.zE
      ) {
        window.zE('messenger', 'hide')
        window.zE('messenger:on', 'close', () => {
          setTimeout(() => {
            window.zE('messenger', 'hide')
          }, 300)
        })
      }


      // Zipchat 客服聊天插件
      if (it.dataset.type === 'customer_service_zipchat') {
        const { index, } = it.dataset
        // 只兼容配置在前3的位置
        if (index > 2) return

        // 按钮
        const chatBtn = document.getElementById('widget-chat-button')
        if (chatBtn) {
          it.style.background = 'transparent'
          chatBtn.classList.add('base-fixed-icon', '!right-16', '!lg:j-right-32', '!xl:a-right-32')

          if (
            (this.threeIconSize == 1 && index == 0) ||
            (this.threeIconSize == 2 && index == 1) ||
            (this.threeIconSize == 3 && index == 2)
          ) {
            chatBtn.classList.add('!bottom-412', '!lg:j-bottom-148', '!xl:a-bottom-148')
          }
          if (
            (this.threeIconSize == 2 && index == 0) ||
            (this.threeIconSize == 3 && index == 1)
          ) {
            chatBtn.classList.add('!z-2000', '!bottom-524', '!lg:j-bottom-216', '!xl:a-bottom-216')
          }
          if (this.threeIconSize == 3 && index == 0) {
            chatBtn.classList.add('!z-2000', '!bottom-636', '!lg:j-bottom-284', '!xl:a-bottom-284')
          }
        }
      }

      // 点击事件
      it.onclick = () => {
        const { type, link } = it.dataset

        // 如果是拉新插件
        if (type === 'new_customer_plugin') {
          window.customerPlugin.iconClick()
        }
        // 如果是红包插件
        else if (type === 'red_packet') {
          const url = window.redPacketPlugin.linkUrl
          window.open(url, '_blank')
        }
        else if (type === 'customer_service') {
          // zendesk 客服聊天插件，显示并打开
          if (window.zE) {
            window.zE('messenger', 'show')
            window.zE('messenger', 'open')
          }
        }
        else if (link) {
          window.open(link, '_blank')
        }
      }

      const tipsDOM = it.querySelector('.fixed-icon-tips')
      if (tipsDOM) {
        it.addEventListener('mouseenter', () => tipsDOM.classList.add('active'))
        it.addEventListener('mouseleave', () => tipsDOM.classList.remove('active'))
      }
    })
  }
  initMoreEvent() {
    const moreIcon = document.querySelector('[data-more-icon]')
    const moreIconitems = document.querySelector('[data-more-icon-items]')

    // 更新更多 icon 显示
    const updatemoreIconsDisplay = () => {
      const count = moreIcon.dataset.click
      if (count % 2) {
        moreIconitems.classList.add('active-more-icon')
        moreIconitems.classList.remove('invisible')
      } else {
        moreIconitems.classList.remove('active-more-icon')
        moreIconitems.classList.add('invisible')
      }
    }

    // 记录点击次数
    let clickCount = 0

    // hover事件
    this.moreIconWrap.addEventListener('mouseenter', () => {
      if (this.moreIconWrap.classList.contains('more-icon-wrap')) {
        this.moreIconWrap.classList.remove('more-icon-wrap')
      }

      moreIconitems.classList.add('active-more-icon')
      moreIconitems.classList.remove('invisible')
    })


    this.moreIconWrap.addEventListener('mouseleave', updatemoreIconsDisplay)

    // 点击事件
    moreIcon.addEventListener('click', () => {
      moreIcon.setAttribute('data-click', ++clickCount)

      updatemoreIconsDisplay()
    })
  }
  // 返回顶部
  initGoBack() {
    const distance = 600
    $(window).scroll(function () {
      if ($(this).scrollTop() > distance) {
        $('#go-back-top').css('opacity', 1)
        $('#go-back-top').css('visibility', 'visible')
      } else {
        $('#go-back-top').css('opacity', 0)
        $('#go-back-top').css('visibility', 'hidden')
      }
    })

    window.Jackery.goBackTopStatus = false; // 全局返回顶部状态位
    if (document.querySelector('#go-back-top')) {
      document.querySelector('#go-back-top').onclick = () => {
        window.Jackery.goBackTopStatus = true;
        window.scrollTo({ top: 0, behavior: 'smooth' })
        $('html,body').animate({
          scrollTop: 0
        }, 500, function () {
          window.Jackery.goBackTopStatus = false;
        });
        return false
      }
    }
  }
}

export default () => {
  var targetNode = document.body;
  var observerOptions = {
    childList: true, // 观察目标子节点的变化，是否有添加或删除
    subtree: true   // 观察整个子树
  };

  var observer = new MutationObserver(function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.id === 'widget-chat-container') {
            window.FixedIconPlugin = new FixedIcon()
          }
        });
      }
    }
  });

  observer.observe(targetNode, observerOptions);

  // 兼容未配置 zipchat 插件
  window.FixedIconPlugin = window.FixedIconPlugin || new FixedIcon()
}
